import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AppCommonModule} from '../app-common/app-common.module';
import {FormsModule} from '@angular/forms';
import {PermissionsPageComponent} from './pages/permissions-page/permissions-page.component';
import {GroupsListViewComponent} from './components/groups-list-view/groups-list-view.component';
import {TooltipModule} from 'primeng/tooltip';
import {AccordionModule} from 'primeng/accordion';
import {CheckboxModule} from 'primeng/checkbox';
import {PermissionEditorComponent} from './components/permission-editor/permission-editor.component';
import {DialogModule} from 'primeng/dialog';
import {GroupEditorComponent} from './components/group-editor/group-editor.component';
import {GroupBuilderComponent} from './components/group-builder/group-builder.component';
import {DropdownModule} from 'primeng/dropdown';
import {UserModule} from '../user/user.module';
import {RippleModule} from 'primeng/ripple';
import {WidgetLibraryModule} from '../_widget-library/widget-library.module';
import {LayoutLibraryModule} from '../_layout-library/layout-library.module';


@NgModule({
  declarations: [
    PermissionsPageComponent,
    GroupsListViewComponent,
    PermissionEditorComponent,
    GroupEditorComponent,
    GroupBuilderComponent,
  ],
    imports: [
        CommonModule,
        AppCommonModule,
        FormsModule,
        TooltipModule,
        AccordionModule,
        CheckboxModule,
        DialogModule,
        DropdownModule,
        UserModule,
        RippleModule,
        WidgetLibraryModule,
        LayoutLibraryModule,
    ],
  exports: [
    PermissionsPageComponent,
  ],
})
export class PermissionModule {
}
